<template>
    <div class="bottom-footer">
        <div class="bottom-footer-width">
            <Row :gutter="0">
                <Col span="18">
                    <Row :gutter="10" justify="center">
                        <Col span="5">
                            <h3>公司概况</h3>
                            <p>
                                <router-link tag="a" :to="{ name: 'profile'}" >公司简介</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'culture'}">公司文化</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'news'}">新闻动态</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'trends'}">党建动态</router-link>
                            </p>
                        </Col>
                        <Col span="4">
                            <h3>产品中心</h3>
                            <p>
                                <router-link tag="a" :to="{ name: 'product-list'}" >产品列表</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'solution'}">解决方案</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'product-consult'}">在线咨询</router-link>
                            </p>
                        </Col>
                        <Col span="4">
                            <h3>营销与服务</h3>
                            <p>
                                <router-link tag="a" :to="{ name: 'outlet'}" >营销网络</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'network'}">服务网点</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'overseas-market'}">海外市场</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'service'}">服务承诺</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'quality'}">质量体系</router-link>
                            </p>
                        </Col>
                        <Col span="5">
                            <h3>研发与制造</h3>
                            <p>
                                <router-link tag="a" :to="{ name: 'development'}" >研发能力</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'produce'}">制造能力</router-link>
                            </p>
                        </Col>
                        <Col span="4">
                            <h3>联系我们</h3>
                            <p>
                                <router-link tag="a" :to="{ name: 'contact-us'}" >联系方式</router-link>
                            </p>
                            <p>
                                <router-link tag="a" :to="{ name: 'join-us'}" >招募英才</router-link>
                            </p>
                        </Col>
                        <Col span="2">&nbsp;</Col>
                    </Row>
                </Col>
                <Col span="6">
                    <Row>
                        <Col span="24">
                            <img class="qr-code" src="../../public/img/随专微信公众号二维码.jpg" alt="">
                        </Col>
                        <!-- <Col span="12">
                            <img class="qr-code" src="../../public/img/1539170074.png" alt="">
                        </Col> -->
                    </Row>
                    <div class="address">
                        <p>地址:&nbsp;湖北省随州市交通大道267号</p>
                        <p>电话:&nbsp;0722-3319657</p>
                        <p>
                            <span>
                                <i class="fa fa-wechat" aria-hidden="true"></i>
                            </span>
                            <!-- <span>
                                <i class="fa fa-weibo" aria-hidden="true"></i>
                            </span> -->
                        </p>
                    </div>
                </Col>
            </Row>
            <div class="statement">
                <p>版权所有&copy;东风随州专用汽车有限公司 All Rights Reserved.</p>
                <p>ICP备案号:&nbsp;11000962号-1</p>
                <p>地址:&nbsp;湖北省随州市交通大道267号</p>
                <!-- <p>电话:&nbsp;0722-3319657</p> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BottomFooter"
    }
</script>

<style scoped lang="stylus">
    .bottom-footer
        padding 32px 10px 0px
        margin 0px auto 0px
        width 100%
        height 320px
        background-color ghostwhite
        .bottom-footer-width
            width 1000px
            margin 0 auto
            h3
                padding-bottom 20px
            p
                a
                    color dimgray
                    font-size 12px
                    line-height 2
            .qr-code
                float right
                display block
                background-color gray
                width 100px
                height 100px
            .address
                color dimgray
                padding-top 20px
                text-align right
                p
                    span
                        display block
                        float right
                        margin 10px 5px 0px
                        background-color black
                        border-radius 50%
                        padding 4px
                        i
                            font-size 16px
                            color white
            .statement
                padding-top 120px
                padding-bottom 38px
                p
                    color dimgray
</style>
